import React from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiCheck,FiArrowUpRight}=FiIcons;

const SeatCard=({seat,onApply})=> (
  <div className={`flex h-full flex-col border p-7 sm:p-8 ${seat.featured ? 'border-black bg-neutral-50' : 'border-neutral-300 bg-white'}`}>
    <p className="mb-3 text-xs font-bold uppercase tracking-[0.16em] text-neutral-500">
      {seat.tier}
    </p>
    <h3 className="mb-3 text-3xl font-black uppercase text-black">{seat.name}</h3>
    <p className="mb-7 min-h-12 text-base leading-relaxed text-neutral-700">
      {seat.audience}
    </p>
    <div className="mb-7 border-y border-neutral-300 py-5">
      <p className="text-xs font-bold uppercase tracking-[0.14em] text-neutral-500">
        Monthly Investment
      </p>
      <p className="mt-2 text-3xl font-black text-black">{seat.price}</p>
      {seat.featured && (
        <p className="mt-2 text-xs font-semibold uppercase tracking-wide text-neutral-600">
          Three-month agreement required
        </p>
      )}
    </div>
    <ul className="mb-9 space-y-4">
      {seat.features.map((feature)=> (
        <li key={feature} className="flex items-start gap-3 text-sm leading-relaxed text-neutral-800">
          <SafeIcon icon={FiCheck} className="mt-0.5 shrink-0 text-base text-black" />
          {feature}
        </li>
      ))}
    </ul>
    <button
      onClick={()=> onApply(seat)}
      className="mt-auto flex w-full items-center justify-center gap-2 border border-black bg-black py-4 text-sm font-black uppercase tracking-wide text-white transition hover:bg-neutral-800"
    >
      {seat.button}
      <SafeIcon icon={FiArrowUpRight} />
    </button>
  </div>
);

export default SeatCard;